import React from 'react';

import styles from './Title.module.scss';
interface TitleProps {
  children: string;
}

export const Title = ({ children }: TitleProps) => {
  return (
    <div className={styles.title} data-testid="mre-popup-title">
      {children}
    </div>
  );
};
